// src/pages/income/service/IncomeServiceDraftPreviewWindow.jsx
// ✅ 용역사업 미리보기 새 창 — _shared/IncomeDraftPreviewWindow.jsx와 동일한
// sessionStorage+BroadcastChannel 패턴이지만, 이 사업은 전용 페이지(IncomeServiceDraftNew)
// 가 자기 채널 이름을 직접 관리하므로 그 상수를 그대로 맞춰 쓴다(config 객체 불필요).
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import IncomeProposalPreview from "../../../components/preview/income/IncomeProposalPreview";

const PREVIEW_STORAGE_KEY = "income-service-draftPreviewData";
const PREVIEW_CHANNEL_NAME = "income-service-draft-preview";

export default function IncomeServiceDraftPreviewWindow() {
  const [searchParams] = useSearchParams();
  const autoDownload = searchParams.get("action") === "download";
  const autoPrint = searchParams.get("action") === "print";

  const readStoredData = () => {
    try {
      const raw = sessionStorage.getItem(PREVIEW_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const [data, setData] = useState(readStoredData);

  useEffect(() => {
    if (!("BroadcastChannel" in window)) return;
    const channel = new BroadcastChannel(PREVIEW_CHANNEL_NAME);
    channel.onmessage = (e) => {
      if (e.data?.type === "update") setData(e.data.payload);
      if (e.data?.type === "clear") setData(null);
    };
    return () => channel.close();
  }, []);

  useEffect(() => {
    if (!autoDownload || !data) return;
    const timer = setTimeout(() => document.querySelector(".download-button")?.click(), 600);
    return () => clearTimeout(timer);
  }, [autoDownload, data]);

  useEffect(() => {
    if (!autoPrint || !data) return;
    const timer = setTimeout(() => window.print(), 600);
    return () => clearTimeout(timer);
  }, [autoPrint, data]);

  useEffect(() => { document.title = "기안 문서 미리보기"; }, []);

  if (!data) {
    return <div style={{ padding: 24, fontSize: 14, color: "#666" }}>작성 중인 문서가 없습니다.</div>;
  }

  return (
    <div className="preview-window-page" style={{ padding: 16 }}>
      <style>{`@media print { .preview-window-page { padding: 0 !important; } }`}</style>
      <IncomeProposalPreview formData={data.formData} approvalLine={data.approvalLine} />
    </div>
  );
}
